import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Tooltip, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { SlaLevelType } from 'constants/slaGroups';

import { selectAllRolesAndUsersById } from 'store/underwriting/selectors';

import {
  cellValueIconStyles,
  cellValueTextStyles,
  cellValueWrapperStyles,
} from './SlaGroupInfoModal.styles';

const SlaTypeCell = ({ level }) => {
  const allRolesAndUsersById = useSelector(selectAllRolesAndUsersById);
  const isTypeUser = level?.type === SlaLevelType.USER;
  const slaLevelRoleName = allRolesAndUsersById[level?.value]?.name;

  if (isTypeUser) {
    return <Typography variant="regular16">{level.type}</Typography>;
  }

  return (
    <Box sx={cellValueWrapperStyles}>
      <Typography sx={cellValueTextStyles} variant="regular16">
        {level.type}
      </Typography>
      <Tooltip placement="top" title={slaLevelRoleName}>
        <Box sx={cellValueIconStyles}>
          <InfoIcon />
        </Box>
      </Tooltip>
    </Box>
  );
};

SlaTypeCell.propTypes = {
  level: PropTypes.object.isRequired,
};

export default memo(SlaTypeCell);
